import React, { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import PageSeo from '@framework/seo/PageSeo';
import MetaSchema from '@/creditflowresearch/ui/common/components/MetaSchema';
import getDealMetaSchema from '@/creditflowresearch/ui/components/deals/Deal/getDealMetaSchema';
import { getDealRoute } from '@/creditflowresearch/Router/RouteWithRedirect/getNewRoute';
import { formatDealName } from '@/creditflowresearch/application/Deal/helpers';
import useHeaderMenuData from '@/creditflowresearch/application/HeaderMenu/useHeaderMenuData';
import { useDealPageContext } from '@/creditflowresearch/application/Deal/contexts/DealPageContext';
import { withDealPageContext } from '@/creditflowresearch/ui/components/deals/DealTiles/withDealPageContext';
import ProductPageHeader from '@/creditflowresearch/ui/common/components/templates/ProductPageHeader/ProductPageHeader';
import { useProductGradient } from '@/creditflowresearch/ui/common/hooks/products/useProductGradient';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { Product } from '@/creditflowresearch/domain/Product';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import { useIsOpenAccessDeal } from '@/creditflowresearch/application/User/access/grants/OpenAccessDealContext';

const DealHeader = () => {
  const { deal } = useDealPageContext();
  const { isHeaderInitialized } = useHeaderMenuData();
  const { asPath: pathname, push } = useRouter();
  const { checkAccessByUserPlan } = useUserPlanContext();
  const panelBackground = useProductGradient(Product.from(deal?.product?.id).getType());
  // TODO: remove when the European market opening period ends
  const isOpenAccessDeal = useIsOpenAccessDeal();

  const pageTitle = useMemo(() => (deal ? formatDealName(deal) : ''), [deal]);
  const correctDealRoute = useMemo(() => (deal ? getDealRoute(deal) : ''), [deal]);

  useEffect(() => {
    if (isHeaderInitialized) {
      if (correctDealRoute !== pathname) {
        push(correctDealRoute, undefined, { shallow: true });
      }
    }
  }, [isHeaderInitialized, deal.viewId, correctDealRoute, pathname, push]);

  if (!deal) {
    return null;
  }

  return (
    <>
      <MetaSchema schema={ getDealMetaSchema(correctDealRoute, deal) } />
      <PageSeo title={ pageTitle } />
      <ProductPageHeader
        title={ pageTitle }
        blockingAccessConditions={ [{ checks: [isOpenAccessDeal || checkAccessByUserPlan(UserPlanType.STARTER)] }] }
        panelBackground={ panelBackground }
      />
    </>
  );
};

export default withDealPageContext(DealHeader);
